/**
 * @ngdoc controller
 * @name TosController
 * @description
 * This component renders the TOS section.
 *
 * @memberof campaigns
 */
class TosController {
  /**
   * Class constructor
   * @param {Service} $http                   To get the TOS text from the server.
   * @param {Service} $location               To redirect the user when the save process finishes.
   * @param {Service} ccaSession              To get the selected account.
   * @param {Service} contentCreatorAdminAPI  To save the TOS content.
   * @param {Service} errorHandler            To show any errors.
   * @ignore
   */
  constructor(
    $http,
    $location,
    ccaSession,
    contentCreatorAdminAPI,
    errorHandler,
  ) {
    'ngInject';

    /**
     * The local reference to the `$http` service.
     * @type {Object}
     */
    this.$http = $http;
    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `contentCreatorAdminAPI` service.
     * @type {Object}
     */
    this.contentCreatorAdminAPI = contentCreatorAdminAPI;
    /**
     * The local reference to the `errorHandler` service.
     * @type {Object}
     */
    this.errorHandler = errorHandler;
    /**
     * The local reference to the `account` object.
     * @type {Object}
     */
    this.account = ccaSession.getSelectedAccount();
    /**
     * The TOS text to display.
     * @type {?String}
     */
    this.tosText = null;
    /**
     * If a request is in progress.
     * @type {Boolean}
     */
    this.isWorking = false;
  }
  /**
   * If the TOS type is text then get the text from the server.
   */
  $onInit() {
    if (this.account.customer.tos.url_interpretation === 'text') {
      this.isWorking = true;
      this.$http.get(this.account.customer.tos.url)
      .then((response) => {
        this.tosText = response.data;
      })
      .catch(() => {
        this.errorHandler.showErrorMessage('Couldn\'t read the TOS file from the server.');
      })
      .finally(() => {
        this.isWorking = false;
      });
    } else {
      this.tosText = this.account.customer.tos.url;
    }
  }
  /**
   * Handle the save tos action.
   */
  saveTos() {
    this.isWorking = true;
    this.contentCreatorAdminAPI.uploadText(this.tosText, 'tos')
    .then((response) => {
      const tos = {
        url: response.resource_url,
        url_interpretation: 'text',
      };
      return this.contentCreatorAdminAPI.saveTos({
        url: response.resource_url,
        url_interpretation: 'text',
      }).then(() => {
        angular.merge(this.account.customer.tos, tos);
        this.$location.url('/campaigns');
      });
    })
    .catch((err) => this.errorHandler.handleError(err))
    .finally(() => {
      this.isWorking = false;
    });
  }
}

export default TosController;



// WEBPACK FOOTER //
// ./src/frontend/modules/tos/components/tos/tos.controller.js